var map = {
	"./de/broadtech.json": 456,
	"./de/business.json": 457,
	"./de/cases.json": 458,
	"./de/common.json": 459,
	"./de/contactus.json": 460,
	"./de/error.json": 461,
	"./de/expectations.json": 462,
	"./de/interactions.json": 463,
	"./de/job.json": 464,
	"./de/meta.json": 465,
	"./de/modal.json": 466,
	"./de/navigation.json": 467,
	"./de/paradox.json": 468,
	"./de/pdp.json": 469,
	"./de/performance.json": 470,
	"./de/showcase.json": 471,
	"./de/startup.json": 472,
	"./de/team.json": 473,
	"./de/technology.json": 474,
	"./en/broadtech.json": 475,
	"./en/business.json": 476,
	"./en/cases.json": 477,
	"./en/common.json": 478,
	"./en/contactus.json": 479,
	"./en/error.json": 480,
	"./en/expectations.json": 481,
	"./en/interactions.json": 482,
	"./en/job.json": 483,
	"./en/meta.json": 484,
	"./en/modal.json": 485,
	"./en/navigation.json": 486,
	"./en/paradox.json": 487,
	"./en/pdp.json": 488,
	"./en/performance.json": 489,
	"./en/showcase.json": 490,
	"./en/startup.json": 491,
	"./en/team.json": 492,
	"./en/technology.json": 493,
	"./ru/broadtech.json": 494,
	"./ru/business.json": 495,
	"./ru/cases.json": 496,
	"./ru/common.json": 497,
	"./ru/contactus.json": 498,
	"./ru/error.json": 499,
	"./ru/expectations.json": 500,
	"./ru/interactions.json": 501,
	"./ru/job.json": 502,
	"./ru/meta.json": 503,
	"./ru/modal.json": 504,
	"./ru/navigation.json": 505,
	"./ru/paradox.json": 506,
	"./ru/pdp.json": 507,
	"./ru/performance.json": 508,
	"./ru/showcase.json": 509,
	"./ru/startup.json": 510,
	"./ru/team.json": 511,
	"./ru/technology.json": 512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 455;